import React from 'react';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';
import Column, { FooterLink } from './atoms/column';
import FooterBottom from './footer-bottom';

export interface FooterColumn {
  header?: string;
  links?: FooterLink[];
  openInNewTab?: boolean;
}
export interface Props {
  columns: FooterColumn[];
  logo?: string;
  socialMedia?: any;
  copyright?: any;
}


const Footer: React.FC<Props> = ({ columns, logo, copyright }) => {

  return (
    <footer
      aria-labelledby="footer-heading"
      className="w-full bg-[#090909] px-24 py-40 md:px-28 md:py-32 lg:px-48 xl:px-60 2xl:px-66 3xl:px-80"
    >
      <div className="hidden w-full justify-between lg:flex ">
        <div className="h-50 w-350 lg:w-200 lg:pr-32 2xl:w-[350px]  3xl:pr-52">
          <Image src={logo} alt="logo" width={250} height={100} />
        </div>
      </div>
      <ul className="flex flex-col items-center lg:hidden">
        <div className="mb-48">
          <Image src={logo} alt="logo" width={194} height={54} />
        </div>
        {columns?.map((column, index) => (
          <li key={index} className={`column-border flex flex-col items-center`}>
            <Column
              header={column?.header}
              links={column?.links ?? []}
              openInNewTab={column?.openInNewTab}
              className="py-12 text-white"
            />
          </li>
        ))}
        <FooterBottom copyright={copyright} />
      </ul>

      <div className="hidden w-full justify-between lg:flex lg:pt-28 2xl:pt-48">
        <FooterBottom copyright={copyright} />
        <div className={`flex flex-row items-center`}>
          {columns?.map((column, index) => (
            <div
              key={index}
              className={`flex flex-row items-center justify-between ${
                index === columns.length - 1 ? '' : 'column-with-separator'
              }`}
            >
              <Column
                header={column?.header}
                links={column?.links ?? []}
                openInNewTab={column?.openInNewTab}
                className=""
              />
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
